// React, store and 3rd party
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import moment from 'moment';

// Components Icons
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';

// Store
import { breadcrumbsActions } from '@store/breadcrumbs';
import { usePermissions } from '@store/auth';
import ApplicationPageTemplate from '@dashboardComponents/ApplicationPageTemplate/ApplicationPageTemplate';
import {
  getGateways,
  paymentOptionsGatewaysActions,
  selectGateways,
} from '../../store/payment-options-gateways';

import {
  GATEWAY_NEW_ROUTE,
  // GATEWAY_LIST_ROUTE,
  viewGateways,
} from '../../payment-options.breadcrumbs';

import TableToolbar from '../../../../components/TableToolbar';

function GatewayToolbar({ navigate, permissions }) {
  return (
    <TableToolbar>
      <Button
        disabled={!permissions?.canEditPaymentOptions}
        variant="contained"
        size="large"
        onClick={() => navigate(GATEWAY_NEW_ROUTE)}
        startIcon={<AddIcon />}>
        Add new gateway
      </Button>
    </TableToolbar>
  );
}

export default function Gateways() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const permissions = usePermissions();

  const [isFetchingData, setIsFetchingData] = useState(true);

  const gateways = useSelector(selectGateways);

  useEffect(() => {
    dispatch(breadcrumbsActions.showMenu(true));
    dispatch(breadcrumbsActions.setBreadcrumbs(viewGateways));
    dispatch(paymentOptionsGatewaysActions.resetSelectedGateway());
  }, [dispatch]);

  useEffect(() => {
    setIsFetchingData(true);
    dispatch(getGateways()).then(() => {
      setIsFetchingData(false);
    });
  }, [dispatch]);

  return (
    <ApplicationPageTemplate
      title="Gateways"
      description="List of available gateways. You can also the page to add and update gateways."
      pageReady={!isFetchingData}>
      <DataGrid
        density="standard"
        style={{ background: 'white' }}
        rows={gateways}
        rowsPerPageOptions={[10]}
        pageSize={10}
        disableSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
        components={{
          Toolbar: () => GatewayToolbar({ navigate, permissions }),
        }}
        componentsProps={{
          toolbar: {
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
        // @TODO: Uncomment once API is available
        // onRowClick={({ row }) => {
        //   navigate(`${GATEWAY_LIST_ROUTE}/${row.id}`);
        // }}
        getRowId={(row) => row.id}
        columns={[
          {
            field: 'id',
            headerName: 'ID',
            sortable: false,
            headerAlign: 'center',
            align: 'center',
          },
          {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            sortable: false,
            headerAlign: 'center',
            align: 'center',
          },
          {
            field: 'code',
            headerName: 'Code',
            flex: 1,
            sortable: false,
            headerAlign: 'center',
            align: 'center',
          },
          // {
          //   field: 'modifiedBy',
          //   headerName: 'Modified By',
          //   flex: 1,
          //   sortable: false,
          //   headerAlign: 'center',
          //   align: 'center',
          // },
          // {
          //   field: 'modifiedAt',
          //   headerName: 'Last Modified Date',
          //   flex: 1,
          //   sortable: false,
          //   headerAlign: 'right',
          //   align: 'right',
          //   valueGetter: ({ row }) =>
          //     moment(row.modifiedAt).format('YYYY/MM/DD - HH:mm'),
          // },
        ]}
      />
    </ApplicationPageTemplate>
  );
}
